module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_5_m.6607ed95fda35e1d7191e101ea651699.png";